import { FC, useState } from "react";
import {
  GenerateBookPDFModalStep1,
  GenerateBookPDFModalStep2,
  GenerateBookPDFModalStep3,
  GenerateBookPDFModalStep4,
  GenerateBookPDFModalStep5,
} from "./GenerateBookPDFModals";

type Props = {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
};

export type Step = {
  id: number;
  name: string;
  status: "complete" | "current" | "upcoming";
};

export const GenerateBookPDFModal: FC<Props> = ({ open, setOpen }) => {
  const [steps, setSteps] = useState<Step[]>([
    { id: 1, name: "Choix du style", status: "current" },
    { id: 2, name: "Personnalisation", status: "upcoming" },
    { id: 3, name: "Infos du livre", status: "upcoming" },
    { id: 4, name: "Résumé", status: "upcoming" },
    { id: 5, name: "Confirmation", status: "upcoming" },
  ]);

  const currentStep = steps.filter((step) => step.status === "current")[0];

  const resetSteps = () => {
    setSteps(() => [
      { id: 1, name: "Choix du style", status: "current" },
      { id: 2, name: "Personnalisation", status: "upcoming" },
      { id: 3, name: "Infos du livre", status: "upcoming" },
      { id: 4, name: "Résumé", status: "upcoming" },
      { id: 5, name: "Confirmation", status: "upcoming" },
    ]);
  };

  const nextStep = () => {
    setSteps((prevSteps) => {
      const currentStepIndex = prevSteps.findIndex(
        (step) => step.status === "current"
      );
      if (currentStepIndex === prevSteps.length - 1) {
        return prevSteps;
      }
      return prevSteps.map((step, index) => {
        if (index === currentStepIndex) {
          return { ...step, status: "complete" };
        } else if (index === currentStepIndex + 1) {
          return { ...step, status: "current" };
        } else {
          return step;
        }
      });
    });
  };

  return (
    <>
      {currentStep.id === 1 && (
        <GenerateBookPDFModalStep1
          open={open}
          setOpen={setOpen}
          steps={steps}
          nextStep={nextStep}
        />
      )}
      {currentStep.id === 2 && (
        <GenerateBookPDFModalStep2
          open={open}
          setOpen={setOpen}
          steps={steps}
          nextStep={nextStep}
        />
      )}
      {currentStep.id === 3 && (
        <GenerateBookPDFModalStep3
          open={open}
          setOpen={setOpen}
          steps={steps}
          nextStep={nextStep}
        />
      )}
      {currentStep.id === 4 && (
        <GenerateBookPDFModalStep4
          open={open}
          setOpen={setOpen}
          steps={steps}
          nextStep={nextStep}
        />
      )}
      {currentStep.id === 5 && (
        <GenerateBookPDFModalStep5
          open={open}
          setOpen={setOpen}
          resetSteps={resetSteps}
        />
      )}
    </>
  );
};
